import axios from "axios";
import { useEffect, useState } from "react";
import InputText from "../../components/Forms/InputText/InputText";
import { useFormik } from "formik";
import Button from "../../components/Button/Button";
import Select from "../../components/Forms/Select/Select";
import { DEFAULT_LANGUAGE, LOCALE, LOCALE_LABELS } from "../../shared/constants";
import Textarea from "../../components/Forms/Textarea/Textarea";
import {
    dssQuestions_DA,
    dssQuestions_DE,
    dssQuestions_EN,
    dssQuestions_ES,
    dssQuestions_HU,
    dssQuestions_NL,
    dssQuestions_PT,
    dssQuestions_TR,
    DEFAULT_OPTIONS,
    dssQuestions_SQ
} from "./questions_dss";
import { formatTemplate } from "../../shared/helpers/utils";

export const request = axios.create({
    baseURL: "http://localhost:3000",
    headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer tfp_2kZ8fKoHjfuenTN82CB99727o3EiW6b5gcBt3NBJG2qB_3pYMswgxWJDMzj`
    }
});

function Typeforms() {
    const [questions, setQuestions] = useState<any[]>([]);
    const [workspace, setWorkspace] = useState<string>("FxTQgr");
    const [title, setTitle] = useState<string>();
    const [params, setParams] = useState<string>();
    const [label, setLabel] = useState<string>();
    const [language, setLanguage] = useState<string>(LOCALE.en);
    const [value, setValue] = useState<string | number>();
    const [options, setOptions] = useState<any>(DEFAULT_OPTIONS);
    const form = useFormik({
        initialValues: {
            question: "",
            description: "",
            options: []
        },
        onSubmit: async (values) => {
            // const opts = values.options.length > 0 ? values.options : options;
            // if (options.length === 0) setOptions(values.options);

            // setQuestions((p) => [...p, { ...values, options: opts }]);
            // form.resetForm();
            // setLabel("");
            // setValue("");

            const question_ranges = [
                { title: "F01 - [{0}]: Workplace culture free of negative acts", range: [0, 1] },
                { title: "F02 - [{0}]: Organisational justice and fairness", range: [2, 4] },
                { title: "F03 - [{0}]: Social support at work", range: [5, 6] },
                { title: "F04 - [{0}]: Balanced work demands", range: [7, 8] },
                { title: "F05 - [{0}]: Job control", range: [9, 9] },
                { title: "F06 - [{0}]: Low-Back Complaints", range: [10, 13] },
                { title: "F07 - [{0}]: Complaints of Upper Extremities", range: [14, 17] }
            ];

            const forms: any = [];

            const languages = Object.keys(LOCALE).forEach((lang) => {
                const ranges = Object.entries(question_ranges).forEach(([_, entry]) => {
                    const title = formatTemplate(entry.title, [lang.toUpperCase()]);
                    const [start, end] = entry.range;
                    const questions = locale_questions[lang].slice(start, end + 1);

                    forms.push(formatTypeform(title, questions, "user_id", "zKwkaX", lang));
                });
            });

            const results = await Promise.allSettled(
                forms.map((form: any) =>
                    request.post("/post-typeform", {
                        data: form,
                        endpoint: "https://api.typeform.com/forms"
                    })
                )
            );

            await Promise.allSettled(
                results
                    .map((result, i) => {
                        if (result.status === "fulfilled") return;
                        return request.post("/post-typeform", {
                            data: {
                                ...forms[i],
                                settings: { ...forms[i].settings, language: DEFAULT_LANGUAGE }
                            },
                            endpoint: "https://api.typeform.com/forms"
                        });
                    })
                    .filter((r) => r)
            );

            const createdForms = await getForms() as any;
            
            await Promise.all(createdForms.data.items.map((form : any) => request.post("/set-webhook", form)));
        }
    });

    const locale_questions: { [key: string]: any[] } = {
        pt: dssQuestions_PT,
        en: dssQuestions_EN,
        sq: dssQuestions_SQ,
        hu: dssQuestions_HU,
        es: dssQuestions_ES,
        da: dssQuestions_DA,
        tr: dssQuestions_TR,
        nl: dssQuestions_NL,
        de: dssQuestions_DE
    };

    useEffect(() => {
        setQuestions(locale_questions[language]);
    }, [language]);

    return (
        <div className="px-1 py-22 px-md-31 pb-22 ">
            <div className="row g-1 mb-1">
                <div className="form col-3">
                    <InputText
                        type="text"
                        label="Workspace"
                        name="form_workspace"
                        placeholder="Workspace id"
                        onChange={(e) => setWorkspace(e.target.value)}
                        value={workspace}
                    />
                </div>
                <div className="form col-3">
                    <InputText
                        type="text"
                        label="Form title"
                        name="form_title"
                        placeholder="Form title"
                        onChange={(e) => setTitle(e.target.value)}
                        value={title}
                    />
                </div>
                <div className="form col-3">
                    <InputText
                        type="text"
                        label="URL parameters"
                        name="form_params"
                        placeholder="param1, param2, etc"
                        onChange={(e) => setParams(e.target.value)}
                        value={params}
                    />
                </div>
                <div className="form col-3">
                    <Select
                        label="Languages"
                        placeholder="Select option"
                        value={[language]}
                        onChange={([lang]) => setLanguage(lang?.value)}
                        options={Object.keys(LOCALE).map((k) => ({
                            label: LOCALE_LABELS[k],
                            value: k
                        }))}
                    />
                </div>
            </div>
            <form
                className="form row g-1"
                onSubmit={form.handleSubmit}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                    }
                }}>
                <div className="col-12">
                    <InputText
                        label="Typeform question"
                        type="text"
                        name="question"
                        placeholder="Question"
                        onChange={form.handleChange}
                        value={form.values.question}
                    />
                </div>
                <div className="col-12">
                    <Textarea
                        label="Typeform description"
                        name="description"
                        placeholder="Description"
                        onChange={form.handleChange}
                        value={form.values.description}
                    />
                </div>
                <div className="col-7">
                    <InputText
                        type="text"
                        name="label"
                        value={label}
                        onChange={(e) => setLabel(e.target.value)}
                        placeholder="label"
                    />
                </div>
                <div className="col-3">
                    <InputText
                        min={0}
                        type="number"
                        placeholder="value"
                        name="value"
                        value={value}
                        onChange={(e) => setValue(Number(e.target.value))}
                    />
                </div>
                <div className="col-2">
                    <Button
                        type="button"
                        label="Add"
                        variant="outlined"
                        customCss="w-100"
                        onClick={() => {
                            if (!label || !value) return;
                            form.setFieldValue("options", [
                                ...form.values.options,
                                {
                                    label,
                                    value
                                }
                            ]);
                            setLabel("");
                            setValue("");
                        }}
                    />
                </div>
                {form.values.options.map((op: any, index: number) => (
                    <div className="col-12" key={index}>
                        <div className="row g-1">
                            <div className="col-7">
                                <InputText
                                    type="text"
                                    name="label"
                                    value={op.label}
                                    onChange={(e) => {
                                        const values = [...form.values.options] as any;

                                        values[index] = {
                                            ...values[index],
                                            label: e.target.value
                                        };

                                        form.setFieldValue("options", values);
                                    }}
                                    placeholder="label"
                                />
                            </div>
                            <div className="col-3">
                                <InputText
                                    min={0}
                                    type="number"
                                    placeholder="value"
                                    name="value"
                                    value={op.value}
                                    onChange={(e) => {
                                        const values = [...form.values.options] as any;

                                        values[index] = {
                                            ...values[index],
                                            value: Number(e.target.value)
                                        };

                                        form.setFieldValue("options", values);
                                    }}
                                />
                            </div>
                            <div className="col-2">
                                <Button
                                    type="button"
                                    icon="Misuse"
                                    variant="outlined"
                                    customCss="w-100"
                                    onClick={() => {
                                        form.setFieldValue(
                                            "options",
                                            form.values.options.filter((_, i) => i !== index)
                                        );
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                ))}
                <div className="col-12">
                    <Button type="submit" label="Adicionar" variant="solid" customCss="w-100" />
                </div>
            </form>
            <div className="row mt-2">
                <div className="col-6">
                    <ul className="mt-2">
                        {questions.map((q, i) => (
                            <li key={i} style={{ borderBottom: "1px solid" }} className="row pt-1">
                                <div className="col-10">
                                    <strong className="text-h3-md">
                                        {i}. {q.question}
                                    </strong>
                                    {q.options.map((op: any, i: number) => (
                                        <p key={i}>
                                            {op.label} - {op.value}
                                        </p>
                                    ))}
                                </div>
                                <div className="col-2">
                                    <Button
                                        type="button"
                                        icon="Misuse"
                                        variant="outlined"
                                        customCss="border-0"
                                        onClick={() => {
                                            setQuestions((q) =>
                                                q.filter((_, index) => index !== i)
                                            );
                                        }}
                                    />
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
                {!!title && (
                    <div className="col-6">
                        <textarea
                            style={{
                                width: "100%",
                                height: "500px"
                            }}
                            onChange={() => {}}
                            value={JSON.stringify(
                                formatTypeform(title, questions, params, workspace, language),
                                null,
                                "\t"
                            )}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

export default Typeforms;

export function formatTypeform(
    title: string | undefined,
    questions: {
        question: string;
        description: string;
        options: { label: string; value: string }[];
    }[],
    params: string | undefined,
    workspace: string,
    language: string
) {
    return {
        type: "score_branching",
        title, // translate this property's value
        workspace: {
            href: `https://api.typeform.com/workspaces/${workspace}`
        },
        settings: {
            language: language,
            progress_bar: "proportion",
            meta: {
                allow_indexing: false
            },
            hide_navigation: false,
            is_public: true,
            is_trial: false,
            show_progress_bar: true,
            show_typeform_branding: true,
            are_uploads_public: false,
            show_time_to_complete: true,
            show_number_of_submissions: false,
            show_cookie_consent: false,
            show_question_number: true,
            show_key_hint_on_choices: true,
            autosave_progress: true,
            free_form_navigation: false,
            use_lead_qualification: false,
            pro_subdomain_enabled: false,
            auto_translate: true
        },
        fields: questions.map((q, i: number) => ({
            title: q.question, // translate this property's value
            ref: `question-ref-${i + 1}`,
            properties: {
                description: q.description, // translate this property's value
                randomize: false,
                allow_multiple_selection: false,
                allow_other_choice: false,
                vertical_alignment: true,
                choices: q.options.map((op, opIndex) => ({
                    ref: `option-ref-${i + 1}${opIndex + 1}`,
                    label: op.label // translate this property's value
                }))
            },
            validations: {
                required: true
            },
            type: "multiple_choice"
        })),
        hidden: params?.split(",").map((p) => p.trim()),
        variables: questions.reduce((a, _, i) => {
            return { ...a, [`q${i + 1}`]: 0 };
        }, {}),
        logic: questions.map((q, i) => ({
            type: "field",
            ref: `question-ref-${i + 1}`,
            actions: q.options.map((op, opIndex) => ({
                action: "add",
                details: {
                    target: {
                        type: "variable",
                        value: `q${i + 1}`
                    },
                    value: {
                        type: "constant",
                        value: op.value
                    }
                },
                condition: {
                    op: "is",
                    vars: [
                        {
                            type: "field",
                            value: `question-ref-${i + 1}`
                        },
                        {
                            type: "choice",
                            value: `option-ref-${i + 1}${opIndex + 1}`
                        }
                    ]
                }
            }))
        }))
    };
}

async function getForms() {
    try {
        const TOKEN = "tfp_2kZ8fKoHjfuenTN82CB99727o3EiW6b5gcBt3NBJG2qB_3pYMswgxWJDMzj";
        const headers = new Headers();

        const response = await request.get("/get-typeform?workspace_id=zKwkaX");

        return response;
    } catch (e) {
        console.log(e);
        return [];
    }
}